import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useBillPaymentArcus } from "../../hooks/useBillPaymentArcus";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Route, useLocation, useNavigate } from "react-router-dom";
import FInputt from "../../components/FInputt/FInputt";
import FInputText from "../../components/Finputs/FInputText/FInputText";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import FContainer from "../../components/FContainer/FContainer";

const ConsultAccountScreen = () => {
  const route = useNavigate();
  const { state } = useLocation();
  const { tokenDecoded } = useContext(AuthContext);
  const [accountEditable, setAccountEditable] = useState(true);
  const [amountEditable, setAmountEdiatble] = useState(true);

  const { consultProductBalance } = useBillPaymentArcus();

  const validate = Yup.object({
    paymentAccountNumber: Yup.string()
      .required("Ingresa un valor válido")
      .min(
        state.product.requirements.inputMin,
        `Debe tener mínimo ${state.product.requirements.inputMin} dígitos`
      )
      .max(
        state.product.requirements.inputMax,
        `Debe tener máximo ${state.product.requirements.inputMax} dígitos`
      ),
  });

  const cAccountScreenFormik = useFormik({
    initialValues: {
      paymentAccountNumber: "",
      amount: "",
      description: "",
    },
    onSubmit: (values) => {
      const { paymentAccountNumber, amount, description } = values;
      async function gProductBalance() {
        await consultProductBalance(state.product, paymentAccountNumber);
      }
      gProductBalance();
    },
    validationSchema: validate,
  });

  useEffect(() => {
    cAccountScreenFormik.setFieldValue("paymentAccountNumber", "");

    if (state == null) {
      route("/");
    }
    //console.log(state.product)
  }, []);

  return (
    <>

      {state != null ? (
        <>
          <FContainer>
            <form
              onSubmit={cAccountScreenFormik.handleSubmit}
              className="w-full"
            >
              <div className="py-4 border-0 border-dashed p-3 mb-16 grid place-items-center">
                <img src={state.product.iconUrl} className="w-32 sm:w-48" />

                <FInputText
                  type="NumberInput"
                  maxLength={state.product.requirements.inputMax}
                  title={state.product.requirements.inputTypeLabel}
                  placeholder={state.product.requirements.inputTypeLabel}
                  errorMessage={
                    cAccountScreenFormik.values.paymentAccountNumber == "" ? "" :
                      cAccountScreenFormik.errors.paymentAccountNumber
                  }
                  onChange={(value) => {
                    cAccountScreenFormik.setFieldValue(
                      "paymentAccountNumber",
                      value
                    );
                  }}
                />
                <Fbutton
                  value={"Consultar"}
                  disabled={!cAccountScreenFormik.isValid}
                  onClick={cAccountScreenFormik.handleSubmit}
                />
              </div>
            </form>
          </FContainer>
        </>
      ) : null}
    </>
  );
};
export default ConsultAccountScreen;
